import { render } from "./Settings.vue?vue&type=template&id=53cc84dd&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=53cc84dd&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=53cc84dd&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cc84dd"],['__file',"src/views/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53cc84dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53cc84dd', __exports__)) {
    console.log('reload')
    api.reload('53cc84dd', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=53cc84dd&scoped=true", () => {
    console.log('re-render')
    api.rerender('53cc84dd', render)
  })

}


export default __exports__